import React from "react";
import { IssuePortal } from "@byscott-io/issuesbyscott_client";
import { useAuth } from '@byscott-io/corebyscott';

export default function SupportPage() {
  const { user, currentAccount } = useAuth();

  if (!currentAccount) {
    return (
      <div className="text-center py-8 text-gray-500">
        Loading...
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Support</h1>
        <p className="mt-1 text-sm text-gray-500">
          Report issues or request features for BillingByScott
        </p>
      </div>

      <IssuePortal
        apiUrl={window.ENV?.ISSUESBYSCOTT_API_URL || "http://localhost:5003/api"}
        apiKey={window.ENV?.ISSUESBYSCOTT_API_KEY || ""}
        user={{
          email: user.email,
          external_id: currentAccount.id.toString(),
          name: currentAccount.name,
          external_user_id: user.id.toString(),
          external_user_name: `${user.first_name} ${user.last_name}`,
        }}
      />
    </div>
  );
}
